import { j as i } from "../../jsx-runtime.BREq8dyb.js";
import { faPlus as _, faTrash as J } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as x } from "@fortawesome/react-fontawesome";
import { Box as f, AccordionGroup as k, Accordion as T, AccordionSummary as F, AccordionDetails as E, Typography as g, Button as O, Stack as B } from "@mui/joy";
import { useSnackbar as K } from "notistack";
import { memo as Q, useState as P, useMemo as C, useCallback as w } from "react";
import { audienceRulesTreeSchema as X, AudienceCombinatorOperator as d, AudienceFiltersBooleanOperator as u } from "./models.js";
import U from "./components/AudienceSelector/AudienceSelector.js";
import W from "./components/AudienceSwitch/AudienceSwitch.js";
import q from "./components/AudienceFilter/AudienceFilter.js";
import Z from "./components/CombinatorChip/CombinatorChip.js";
import I from "./components/AddAudienceButton/AddAudienceButton.js";
const v = Q(({
  config: p,
  defaultValue: $,
  onTreeChange: A
}) => {
  const {
    enqueueSnackbar: L
  } = K(), [n, S] = P($ || {
    combine: [],
    filters: void 0,
    name: "",
    source_ref: null
  }), [b, j] = P(/* @__PURE__ */ new Set([0])), Y = C(() => X.safeParse({
    ...n,
    id: "draft_id"
  }), [n]), o = w((r) => S(typeof r == "function" ? (e) => {
    const t = r(e);
    return A(t), t;
  } : () => (A(r), r)), [A]), G = w((r) => {
    o({
      combine: null,
      filters: null,
      ...r ? {
        name: r.name,
        source_ref: r.id
      } : {
        name: "",
        source_ref: ""
      }
    });
  }, [o]), M = (r, e) => {
    o((t) => ({
      ...t,
      combine: t.combine?.map((s, l) => l === e ? {
        ...s,
        name: r?.name || "",
        source_ref: r?.id || ""
      } : s)
    }));
  }, D = (r) => {
    o((e) => r !== void 0 ? {
      ...e,
      combine: e.combine?.map((t, s) => s === r ? {
        ...t,
        filters: {
          filters: [...t.filters?.filters || [], {
            attribute: null,
            condition: null,
            values: []
          }],
          operator: t.filters?.operator || u.AND
        }
      } : t)
    } : {
      ...e,
      filters: {
        filters: [...e.filters?.filters || [], {
          attribute: null,
          condition: null,
          values: []
        }],
        operator: e.filters?.operator || u.AND
      }
    });
  }, V = (r, e) => {
    r.stopPropagation(), o((t) => ({
      ...t,
      combine: e === 0 && t.combine?.length === 1 ? null : t.combine?.filter((s, l) => l !== e)
    })), j(/* @__PURE__ */ new Set([n.combine ? n.combine.length - 1 : 1]));
  }, z = (r) => {
    if (Y.error)
      return L("Please fill the all necessary attributes, conditions and values to proceed", {
        persist: !0,
        variant: "info"
      });
    j(/* @__PURE__ */ new Set([n.combine ? n.combine.length + 1 : 1])), o((e) => ({
      ...e,
      combine: [...e.combine || [], {
        filters: null,
        name: "",
        operator: r,
        source_ref: null
      }]
    }));
  }, H = C(() => {
    if (n?.combine && n.combine.length > 0) {
      if (n.combine[0].operator === d.UNION)
        return [d.UNION];
      if (n.combine[0].operator === d.INTERSECT)
        return [d.INTERSECT];
      if (n.combine[0].operator === d.DIFF)
        return [];
    }
    return [d.INTERSECT, d.UNION, d.DIFF];
  }, [n?.combine]), N = C(() => (r, e) => {
    o((t) => e !== void 0 ? {
      ...t,
      combine: t.combine?.map((s, l) => l === e && s.filters ? {
        ...s,
        filters: r === 0 && s.filters.filters.length === 1 ? null : {
          ...s.filters,
          filters: s.filters?.filters?.filter((a, c) => c !== r)
        }
      } : s)
    } : {
      ...t,
      filters: t.filters ? t.filters.filters.length === 1 && r === 0 ? null : {
        ...t.filters,
        filters: t.filters?.filters?.filter((s, l) => l !== r)
      } : t.filters
    });
  }, [o]), y = (r, e) => {
    o((t) => e !== void 0 ? {
      ...t,
      combine: t.combine?.map((s, l) => l === e && s.filters ? {
        ...s,
        filters: {
          ...s.filters,
          operator: r ? u.AND : u.OR
        }
      } : s)
    } : {
      ...t,
      filters: t.filters ? {
        ...t.filters,
        operator: r ? u.AND : u.OR
      } : t.filters
    });
  }, R = w((r, e, t) => {
    o((s) => t !== void 0 ? {
      ...s,
      combine: s.combine?.map((l, a) => a === t && l.filters ? {
        ...l,
        filters: {
          ...l.filters,
          filters: l.filters?.filters?.map((c, h) => h === e ? r : c)
        }
      } : l)
    } : {
      ...s,
      filters: s.filters ? {
        ...s.filters,
        filters: s.filters?.filters?.map((l, a) => a === e ? r : l)
      } : s.filters
    });
  }, [o]);
  return /* @__PURE__ */ i.jsxs(f, { width: "100%", children: [
    /* @__PURE__ */ i.jsx(k, { children: /* @__PURE__ */ i.jsxs(T, { "data-testid": "default-audience-selector", defaultExpanded: !0, expanded: b.has(0), onChange: (r, e) => j((t) => e ? t.union(/* @__PURE__ */ new Set([0])) : t.difference(/* @__PURE__ */ new Set([0]))), children: [
      /* @__PURE__ */ i.jsx(F, { children: "Audience 1" }),
      /* @__PURE__ */ i.jsxs(E, { sx: {
        "--ListItem-paddingY": 0
      }, children: [
        /* @__PURE__ */ i.jsx(U, { audienceConfigs: p, chipText: "Users who belong to: ", onSelect: G, testId: "default-audience-select", value: n?.source_ref ?? null }),
        /* @__PURE__ */ i.jsx(g, { sx: {
          m: 1
        }, children: "With the following filters:" }),
        n?.filters?.filters.length ? /* @__PURE__ */ i.jsx(f, { sx: (r) => ({
          backgroundColor: r.palette.primary[100],
          borderRadius: r.radius.sm,
          px: 1,
          py: 2
        }), children: n?.filters?.filters.map(({
          condition: r,
          attribute: e,
          values: t
        }, s) => /* @__PURE__ */ i.jsxs(f, { children: [
          n?.filters?.filters && s !== 0 && n.filters.filters.length > 1 && /* @__PURE__ */ i.jsx(W, { checked: n.filters.operator === u.AND, onChange: (l) => y(l.target.checked) }),
          /* @__PURE__ */ i.jsx(q, { attribute: e, attributes: p.find(({
            id: l
          }) => l === n.source_ref)?.attributes || {}, condition: r, handleRemove: () => N(s), onChange: (l) => R(l, s), values: t })
        ] }, s)) }) : null,
        /* @__PURE__ */ i.jsx(f, { children: /* @__PURE__ */ i.jsx(O, { color: "primary", onClick: () => D(), startDecorator: /* @__PURE__ */ i.jsx(x, { fixedWidth: !0, icon: _ }), sx: {
          my: 1
        }, variant: "plain", children: "Add a new filter" }) })
      ] })
    ] }) }),
    n?.combine?.map((r, e) => {
      const {
        operator: t,
        source_ref: s
      } = r;
      return /* @__PURE__ */ i.jsxs(f, { children: [
        t && /* @__PURE__ */ i.jsx(B, { direction: "row", justifyContent: "center", spacing: 1, width: "100%", children: /* @__PURE__ */ i.jsx(Z, { operator: t }) }),
        /* @__PURE__ */ i.jsx(k, { children: /* @__PURE__ */ i.jsxs(T, { defaultExpanded: !0, expanded: b.has(e + 1), onChange: (l, a) => j((c) => a ? c.union(/* @__PURE__ */ new Set([e + 1])) : c.difference(/* @__PURE__ */ new Set([e + 1]))), children: [
          /* @__PURE__ */ i.jsx(F, { children: /* @__PURE__ */ i.jsxs(B, { alignItems: "center", direction: "row", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ i.jsxs(g, { children: [
              "Audience ",
              e + 2
            ] }),
            /* @__PURE__ */ i.jsx(x, { icon: J, onClick: (l) => V(l, e) })
          ] }) }),
          /* @__PURE__ */ i.jsxs(E, { sx: {
            "--ListItem-paddingY": 0
          }, children: [
            /* @__PURE__ */ i.jsx(U, { audienceConfigs: p, onSelect: (l) => M(l, e), value: s }),
            /* @__PURE__ */ i.jsx(g, { sx: {
              m: 1
            }, children: "With the following filters:" }),
            r.filters?.filters.length ? /* @__PURE__ */ i.jsx(f, { sx: (l) => ({
              backgroundColor: l.palette.primary[100],
              borderRadius: l.radius.sm,
              p: 1
            }), children: r.filters?.filters.map(({
              attribute: l,
              condition: a,
              values: c
            }, h) => /* @__PURE__ */ i.jsxs(f, { children: [
              h !== 0 && /* @__PURE__ */ i.jsx(W, { checked: r.filters?.operator === u.AND, onChange: (m) => y(m.target.checked, e) }),
              /* @__PURE__ */ i.jsx(q, { attribute: l, attributes: p.find(({
                id: m
              }) => m === s)?.attributes || {}, condition: a, handleRemove: () => N(h, e), onChange: (m) => R(m, h, e), values: c })
            ] }, `${e}-${h}-${s}`)) }) : null,
            /* @__PURE__ */ i.jsx(f, { children: /* @__PURE__ */ i.jsx(O, { color: "primary", onClick: () => D(e), startDecorator: /* @__PURE__ */ i.jsx(x, { fixedWidth: !0, icon: _ }), sx: {
              my: 1
            }, children: "Add a new filter" }) })
          ] })
        ] }) })
      ] }, e);
    }),
    /* @__PURE__ */ i.jsx(I, { combinatorOperators: H, handleAddAudience: z })
  ] });
});
v.displayName = "DqAudienceRulesBuilder";
export {
  v as default
};
//# sourceMappingURL=DqAudienceRulesBuilder.js.map
